import { render, staticRenderFns } from "./Paso4.vue?vue&type=template&id=fd505108&scoped=true"
import script from "./Paso4.vue?vue&type=script&lang=js"
export * from "./Paso4.vue?vue&type=script&lang=js"
import style0 from "./Paso4.vue?vue&type=style&index=0&id=fd505108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd505108",
  null
  
)

export default component.exports